import { getCookieDomain } from '@/utils/cookie'
import { useAppStore } from '@/stores/app'
import i18nConfig from '@/config/i18n'

export default defineNuxtRouteMiddleware(async (to) => {
  const appStore = useAppStore()
  const { fetchUser } = useAuth()
  const loginToken = to.query.utkn

  if (!loginToken) {
    return
  }

  // Initialize cookies with maxAge to ensure they persist
  // Following the pattern from plugins/auth.ts and composables/useAuth.ts
  const tokenCookie = useCookie('apollo-token', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const expiresCookie = useCookie('apollo-expires', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  // Set the token cookie value
  tokenCookie.value = String(loginToken)

  // Set the expires cookie value (1 hour from now in seconds)
  expiresCookie.value = String(Math.floor((Date.now() + 60 * 60 * 1000) / 1000))

  try {
    const user = await fetchUser()
    const country = user?.user?.country?.name?.toLowerCase() || i18nConfig.defaultCountry
    const i18Params = `/${appStore.locale}-${country}`

    return navigateTo(`${i18Params}/account`)
  } catch (error) {
    // Clear cookies on error
    tokenCookie.value = null
    expiresCookie.value = null

    console.error(error)
  }
})
